// KS — Custom JS
// Shipping Protection via AJAX + auto clean when it's the only item

(function () {
  const PROTECT_VARIANT_ID = 46846832935164;
  const PROTECT_HANDLE = 'shipping-protection';

  function showTotalsLoading() {
    const overlay = document.getElementById('cart-total-price-ovarlay');
    if (overlay) overlay.classList.add('loading');
  }

  function hideTotalsLoading() {
    const overlay = document.getElementById('cart-total-price-ovarlay');
    if (overlay) overlay.classList.remove('loading');
  }

  function addShippingProtection(variantId) {
    showTotalsLoading();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function () {
        // Refresh drawer/cart UI using your helper from cart-drawer.liquid
        if (typeof ksRefreshCartDrawerSectionsExact === 'function') {
          return ksRefreshCartDrawerSectionsExact();
        }
      })
      .catch(function (err) {
        console.error('Error adding shipping protection:', err);
      })
      .finally(function () {
        hideTotalsLoading();
      });
  }

  function removeShippingProtection(variantId) {
    showTotalsLoading();

    const updates = {};
    updates[variantId] = 0;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        if (typeof ksRefreshCartDrawerSectionsExact === 'function') {
          return ksRefreshCartDrawerSectionsExact();
        }
      })
      .catch(function (err) {
        console.error('Error removing shipping protection:', err);
      })
      .finally(function () {
        hideTotalsLoading();
      });
  }

  // 🔥 Global helper we’ll call from cart.js after any quantity/remove
  window.ksEnforceShippingProtection = function () {
    // Small delay so /cart/change has finished
    setTimeout(function () {
      fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) return;

          const items = cart.items;

          const realItems = items.filter(function (item) {
            return item.handle !== PROTECT_HANDLE;
          });

          const hasProtection = items.some(function (item) {
            return item.handle === PROTECT_HANDLE;
          });

          // If there are NO normal items left but shipping protection is still there → remove it
          if (realItems.length === 0 && hasProtection) {
            const updates = {};
            updates[PROTECT_VARIANT_ID] = 0;

            showTotalsLoading();

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            })
              .then(function () {
                if (typeof ksRefreshCartDrawerSectionsExact === 'function') {
                  return ksRefreshCartDrawerSectionsExact();
                }
              })
              .catch(function (err) {
                console.error('Error auto-removing lonely shipping protection:', err);
              })
              .finally(function () {
                hideTotalsLoading();
              });
          }
        })
        .catch(function (err) {
          console.error('Error enforcing shipping protection rule:', err);
        });
    }, 350);
  };

  function onDocumentReady() {
    // Shipping protection checkbox toggle
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('change', '#shipping_protection', function () {
        const $checkbox = jQuery(this);
        const $container = $checkbox.closest('.shipping-protection-container');
        const variantId = $container.data('protection-variant-id');

        if (!variantId) {
          console.warn('Shipping protection: variant id not found on container');
          return;
        }

        if ($checkbox.prop('checked')) {
          addShippingProtection(variantId);
        } else {
          removeShippingProtection(variantId);
        }
      });
    } else {
      // Vanilla fallback
      document.addEventListener('change', function (e) {
        if (!e.target.matches('#shipping_protection')) return;

        const checkbox = e.target;
        const container = checkbox.closest('.shipping-protection-container');
        if (!container) return;

        const variantId = container.getAttribute('data-protection-variant-id');
        if (!variantId) {
          console.warn('Shipping protection: variant id not found on container');
          return;
        }

        if (checkbox.checked) {
          addShippingProtection(variantId);
        } else {
          removeShippingProtection(variantId);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  } else {
    onDocumentReady();
  }
})();
